import React from "react";

import { cn } from "@/lib/utils";

/**
 * One setting: what it is on the left, the control on the right.
 *
 * The same bordered row carries an org-settings toggle, a prompt-safety switch
 * and a module kill switch. It was written out once per screen before, and the
 * three copies had already drifted in padding and in where the badges sat.
 *
 * `title` and `description` are the setting. `badges` sits beside the title —
 * a "Locked" tag, a module code. `note` goes under the description, for the
 * `<Callout>` that says what switching this off does. `control` is the switch,
 * the state pill or a select.
 *
 * @param {ReactNode} [badges]  rendered inline after the title
 * @param {ReactNode} [note]    rendered under the description
 * @param {ReactNode} control   the switch, pill or select
 */
export const SettingRow = ({
  title,
  description,
  badges,
  note,
  control,
  className = "",
  contentClassName = "",
  descriptionClassName = "",
  controlClassName = "pt-1",
}) => (
  <div className={cn("flex items-start gap-4 rounded-lg border border-border-primary/60 p-5", className)}>
    <div className={cn("flex flex-1 flex-col gap-2", contentClassName)}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-text-primary">{title}</span>
        {badges}
      </div>

      {description ? <p className={cn("max-w-[85%] text-[13px] leading-relaxed text-text-secondary", descriptionClassName)}>{description}</p> : null}

      {note}
    </div>

    {control ? <div className={cn("flex-shrink-0", controlClassName)}>{control}</div> : null}
  </div>
);

export default SettingRow;
